// Light, dark or follow the device. Applies at once and is remembered on this device (lib/theme).
import { useState } from 'react';
import { getTheme, setTheme, type Theme } from '@/lib/theme';
import { Segmented } from './Segmented';

const THEMES: ReadonlyArray<{ value: Theme; label: string }> = [
  { value: 'system', label: 'Auto' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

export function ThemeSwitch() {
  const [theme, setCurrent] = useState<Theme>(getTheme);
  const choose = (next: Theme) => {
    setTheme(next);
    setCurrent(next);
  };
  return <Segmented label="Appearance" options={THEMES} value={theme} onChange={choose} />;
}
